import React, { useEffect, useRef } from 'react';

import Lottie from 'lottie-web/build/player/lottie_light';

import lottieData from './animated-sparkles.json';

export const AnimatedSparkles: React.FC<
  React.ComponentPropsWithoutRef<'div'>
> = ({ className, ...props }) => {
  const ref = useRef(null);
  useEffect(() => {
    const instance = Lottie.loadAnimation({
      container: ref.current as unknown as Element,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData: lottieData,
    });

    return () => instance.destroy();
  }, []);

  return (
    <div id="animated-check" ref={ref} className={className} {...props}></div>
  );
};

export type NotifyProps = {
  /**
   * Define custom description for the notify container
   */
  description: string;
  /**
   * Define custom title for the notify container
   */
  title: string;
  /**
   * Optional click handler
   */
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
};

/**
 * Main notify component.
 */
export const Notify: React.FC<NotifyProps> = ({
  description,
  title,
  onClick = () => location.reload(),
}) => {
  return (
    <div className="pointer-events-none fixed inset-0 z-[60]">
      <div className="absolute inset-x-0 top-0 flex justify-center">
        <button
          type="button"
          className="pointer-events-auto absolute top-10 cursor-pointer select-none rounded-lg bg-gray-900 px-6 py-4 text-white shadow-notify duration-500 ease-in-out-cubic animate-in fade-in-0 hover:bg-gray-700 focus:bg-gray-900 focus:shadow-notify-focus"
          onClick={onClick}
        >
          <div className="flex items-center gap-4">
            <AnimatedSparkles className="size-8" />
            <div className="flex flex-col text-left">
              <p className="font-bold">{title}</p>
              <p className="text-sm">{description}</p>
            </div>
          </div>
        </button>
      </div>
    </div>
  );
};

Notify.displayName = 'Notify';
